import React, { useCallback } from 'react';
import { Typography, Icon } from '@npm-registry/eapteka-ui';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../../store';
import { text } from '../../../../text';
import {
  removePromocode,
  selectLoading,
  selectPromocode
} from '../../../../store/promocode';
import { Spinner } from '../../../core/Spinner/Spinner';
import styles from './PromocodeInformer.scss';

export const PromocodeInformer = () => {
  const loading = useSelector(selectLoading);
  const promocode = useSelector(selectPromocode);
  const dispatch: AppDispatch = useDispatch();

  const onCancel = useCallback(() => {
    dispatch(removePromocode());
  }, [dispatch]);

  return (
    <div className={styles.root}>
      <div className={styles.iconWrapper}>
        <Icon className={styles.icon} name="checkmarkAlt" />
      </div>
      <div>
        <Typography variant="p2">
          {text['promocode.applied']}
        </Typography>
        <Typography className={styles.code} weight="strong">
          {promocode}
        </Typography>
      </div>
      <button className={styles.cancel} onClick={onCancel}>
        {loading === 'pending' ? (
          <Spinner color="#8168f0" />
        ) : (
          text['promocode.cancel']
        )}
      </button>
    </div>
  );
};
